module.exports = __webpack_public_path__ + "static/media/undraw_result_5583.dc37cfdf.svg";